import { render } from "./ClientsFilterChips.vue?vue&type=template&id=4b61b7ec&scoped=true"
import script from "./ClientsFilterChips.vue?vue&type=script&lang=js"
export * from "./ClientsFilterChips.vue?vue&type=script&lang=js"

import "./ClientsFilterChips.vue?vue&type=style&index=0&id=4b61b7ec&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b61b7ec"]])

export default __exports__